import React from "react";
import LocationPicker from "../1_atoms/LocationPicker";
import SearchAndSelection from "../2_molecules/SearchAndSelection";

function CitySelection() {
  return (
    <form>
      <SearchAndSelection />
      <LocationPicker />
    </form>
  );
}

export default CitySelection;
